import { Select, SelectProps } from 'zens-storybook'
import React from 'react'
import { StyleSheet } from 'react-native'
import { useCompanies } from 'zens-store'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends Omit<SelectProps<number>, 'items' | 'onSelect'> {
  onChange?: (value: number) => void
  filter?: (companyId: number) => boolean
}

const CompanySelect = (props: Props) => {
  const { onChange, filter, style, ...otherProps } = props

  const companies = useCompanies({})
  const items = companies.data
    ?.filter((company) => !filter || filter(company.id))
    .map((company) => ({
      value: company.id,
      title: company.name,
    }))
    .sort((a, b) => a.title.localeCompare(b.title))
  return (
    <Select
      style={[styles.container, style]}
      onSelect={onChange}
      items={items}
      testID="CompanySelect.Container"
      {...otherProps}
    />
  )
}

export default CompanySelect
